module.exports = __webpack_public_path__ + "img/Business-Network.c9d3ed97.svg";